import React, { useEffect, useState } from "react";
import { getLiveTrackLink } from "../../../api/jobApi";
import LoadingSpinner from "../../LoadingSpinner";

const JobTrackLink = ({ jobId, close }) => {
  const [trackingLink, setTrackingLink] = useState("");
  const [available, setAvailable] = useState(null);
  const [copied, setCopied] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!jobId) return;
    setIsLoading(true);
    getLiveTrackLink(jobId)
      .then((data) => {
        setAvailable(data?.available ?? false);
        setTrackingLink(data?.trackingLink ?? "");
      })
      .catch(() => setAvailable(false))
      .finally(() => setIsLoading(false));
  }, [jobId]);

  const handleCopy = () => {
    if (!trackingLink) return;
    navigator.clipboard.writeText(trackingLink).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <div style={{ padding: "24px", minWidth: 460 }}>
      <label
        style={{
          display: "block",
          fontSize: 16,
          fontWeight: 600,
          color: "#6b7280",
          marginBottom: 10,
          textTransform: "uppercase",
          letterSpacing: "0.06em",
        }}
      >
        External Tracking Link
      </label>

      {isLoading ? (
        <LoadingSpinner />
      ) : available === false ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            fontSize: 14,
            fontWeight: 500,
            color: "#dc2626",
            padding: "12px 14px",
            background: "#fef2f2",
            border: "1px solid #fecaca",
            borderRadius: 8,
          }}
        >
          <i
            className="ti ti-alert-circle"
            style={{ fontSize: 18 }}
            aria-hidden="true"
          />
          Link expired or Not Available
        </div>
      ) : (
        <div
          style={{
            display: "flex",
            alignItems: "stretch",
            border: "1px solid #d1d5db",
            borderRadius: 8,
            overflow: "hidden",
          }}
        >
          <input
            readOnly
            value={trackingLink}
            style={{
              flex: 1,
              minWidth: 0,
              fontSize: 14,
              padding: "10px 14px",
              border: "none",
              background: "#f9fafb",
              color: "#111827",
              cursor: "default",
              outline: "none",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          />
          <button
            type="button"
            onClick={handleCopy}
            title="Copy link"
            style={{
              display: "flex",
              alignItems: "center",
              gap: 6,
              padding: "0 18px",
              fontSize: 14,
              fontWeight: 600,
              border: "none",
              borderLeft: "1px solid #d1d5db",
              background: copied ? "#16a34a" : "#2563eb",
              color: "#ffffff",
              cursor: "pointer",
              transition: "background 0.2s",
              whiteSpace: "nowrap",
            }}
          >
            <i
              className={copied ? "ti ti-check" : "ti ti-copy"}
              style={{ fontSize: 16 }}
              aria-hidden="true"
            />
            {copied ? "Copied" : "Copy"}
          </button>
        </div>
      )}
    </div>
  );
};

export default JobTrackLink;
